<template>
	<div>
		<div class="container container--narrow pdt-50">
			<question-tag
				:correctRate="question.correctRate"
				:avgSolveTime="question.avgSolveTime"
				:level="paperLevel"
			></question-tag>
			<div v-if="groupQuestionCount === 1">
				<div class="mgt-16 t-subtitle6 t-line-h-28 font-rn">
					<vue-mathjax :formula="question.contents.text" v-if="question.useMathjax"></vue-mathjax>
					<div v-else>
						{{ question.contents.text }}
					</div>
				</div>
				<div class="mgt-24" v-if="question && question.contents && question.contents.image">
					<img :src="question.contents.image" alt="" class="b-radius4 ">
				</div>
					<div class="mgt-24">
						<label
							class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea w-full customize-textfield--outlined  mdc-text-field--disabled disabled--Updated"
							data-mdc-auto-init="MDCTextField" :id="`answerEl`">
							<span class="mdc-text-field__ripple"></span>
							<textarea
								class="mdc-text-field__input t-body6 font-r  pdl-14  pdr-15 pdb-34 t-line-h-26 l-spacing2"
								aria-labelledby="my-label-id" rows="11" cols="10"
								v-model="textAnswer"
								readonly disabled></textarea>
							<!-- <span id="label" class="mdc-floating-label text-area-label">{{$t('1257')}}</span> -->
							<span class="mdc-line-ripple"></span>
						</label>
						<div class="mdc-text-field-helper-line mgr--12">
							<div class="mdc-text-field-character-counter t-helper t-color-bodyGrayA"> {{textAnswer && textAnswer.length>0?textAnswer.length:'0'}} / 200  </div>
						</div>
						
					</div>
						<div class="divider mgt-16 mgb-16"></div>
						<div class="mgt-16">
							<div class="mdc-card pdt-20 pdb-19 pdl-24 pdr-24 ">
								<div class="d-flex align-items-center justify-content-between ">
									<div class="t-body1 font-r t-line-h-22">{{$t('1276')}} </div>
									<div>
										<span class="t-body6 font-r pdr-12">{{$t('1277')}}</span>
										<span class="t-headline9 font-rb">{{question.essay.partialScore}}%</span>
									</div>
								</div>
							</div>
						</div>
					<div v-if="question.essay.essentialWordList.length > 0">
						<div class="mgt-24 mgb-16 t-body6 font-rn">
							{{$t('1278')}}
						</div>
						<div class="bg-quizGray b-radius4 pdt-14 pdb-12 pdl-12 pdr-24 mgb-8 mgt-24">
							<div class="d-flex align-items-center">
								<div class="t-body6 t-color-quizBlack font-r flex-grow-1">
									<span v-for="(word, index) in question.essay.essentialWordList" :key="index">
										{{word}}{{question.essay.essentialWordList.length > index+1 ? ', ' : ''}}
									</span>
								</div>
							</div>
						</div>
					</div>
				</div>
		<div v-else>
			<div class="mgt-16 t-body1 t-line-h-28 ">
				{{groupQuestionTitle}}
			</div>
			<div class="mgt-24">
				<div class="mdc-card pda-24 bg-documentGray position-relative grouped-card">
					<div class="t-subtitle6 font-rn t-line-h-26 mgb-24">
						<vue-mathjax :formula="question.contents.text" v-if="question.useMathjax"></vue-mathjax>
						<div v-else>
							{{ question.contents.text }}
						</div>
					</div>
					<div class="mgt-24" v-if="question && question.contents && question.contents.image">
						<img :src="question.contents.image" alt="" class="b-radius4">
					</div>
					<div class="mgt-24">
						<label class="mdc-text-field mdc-text-field--outlined mdc-text-field--textarea w-full customize-textfield--outlined  mdc-text-field--disabled disabled--Updated"
							data-mdc-auto-init="MDCTextField" :id="`answerEl`">
							<span class="mdc-text-field__ripple"></span>
							<textarea class="mdc-text-field__input t-body6 font-r  pdl-15  pdr-24 pdb-32 t-line-h-26 l-spacing2"
								aria-labelledby="my-label-id" rows="3" cols="10"
								v-model="textAnswer"
								readonly disabled>
							</textarea>
							<span id="label" class="mdc-floating-label text-area-label">{{$t('1257')}}</span>
							<span class="mdc-line-ripple"></span>
						</label>
						<div class="mdc-text-field-helper-line mgr--12">
							<div class="mdc-text-field-character-counter t-helper t-color-bodyGrayA"> {{textAnswer && textAnswer.length>0?textAnswer.length:'0'}} / 200  </div>
						</div>
					</div>
						<div class="divider mgt-16 mgb-16"></div>
						<div class="mgt-16">
						<div class="mdc-card pdt-22 pdb-22 pdl-24 pdr-24 ">
							<div class="d-flex align-items-center justify-content-between ">
								<div class="t-body6 font-r t-line-h-22">{{$t('1276')}} </div>
								<div>
									<span class="t-body6 font-r pdr-12">{{$t('1277')}}</span>
									<span class="t-headline9 font-rb">{{question.essay.partialScore}}%</span>
								</div>
							</div>
						</div>
						</div>
						<div v-if="question.essay.essentialWordList.length > 0">
							<div class="mgt-24 mgb-16 t-body6 font-rn">
								{{$t('1278')}}
							</div>
							<div class="bg-quizGray b-radius4 pdt-13 pdb-12 pdl-24 pdr-24 mgb-8 mgt-24  box-54">
								<div class="d-flex align-items-center">
									<div class="t-body6 t-color-quizBlack font-r flex-grow-1">
										<span v-for="(word, index) in question.essay.essentialWordList" :key="index">
											{{word}}{{question.essay.essentialWordList.length > index+1 ? ', ' : ''}}
										</span>
									</div>
								</div>
							</div>
						</div>
						</div>
					</div>
				</div>
			<question-tip v-if="question && question.tip" :tip="question.tip" :marginType="groupQuestionCount === 1 ? true :false"/>
		</div>
		<question-feedback
			:commonFeedback="question.feedback.common"
			:correctFeedback="question.feedback.correct"
			:incorrectFeedback="question.feedback.incorrect"
			:videoFeedback="question.feedback.video"
			:feedbackStatus="feedback"
			:correct="question.correct"
			:questionId="question.questionId"
			:currentGroupIndex="currentGroupIndex"
		></question-feedback>
	</div>
</template>

<script>
/**
 * 에세이 문항 피드백 컴포넌트(essay type question feedback component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import {MDCTextField} from '@material/textfield'
import QuestionTag from './QuestionTag.vue'
import QuestionTip from './QuestionTip.vue'
import QuestionFeedback from './QuestionFeedback.vue'
import {questionMixin} from '@/mixins/question.js'

export default {
	props: ['question', 'groupQuestionCount', 'groupQuestionTitle', 'paperLevel', 'feedback', 'currentGroupIndex'],
	data() {
		return {
			textAnswer: '',
			textCorrect: ''
		}
	},
	components: {
		'question-tag': QuestionTag,
		'question-tip': QuestionTip,
		'question-feedback': QuestionFeedback
	},

	mixins: [questionMixin],

	watch: {
        question (newVar, oldVar) {
            // console.log('setedAnswer=>newVar',newVar)
            // console.log('setedAnswer=>oldVar',oldVar)
            this.textAnswer = JSON.parse(JSON.stringify(this.question.textAnswer))
        }
    },

	mounted() {
		this.textAnswer = this.question.textAnswer
		this.textCorrect = this.question.textCorrect
		const textField = new MDCTextField(document.getElementById(`answerEl`))
	},
}
</script>
